export default {"src":"/_next/static/media/assistance-veterinaire.2432b7ac.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};